// extracted by mini-css-extract-plugin
export var tilesCollectionWrapper = "TileCollection-module--tilesCollectionWrapper--WbgZA";
export var mobileSlider = "TileCollection-module--mobileSlider--ozIbU";
export var card = "TileCollection-module--card--2W38f";
export var tilesCollectionPan = "TileCollection-module--tilesCollectionPan--bGnN5";
export var tilesCollectionContainer = "TileCollection-module--tilesCollectionContainer--33Ctz";
export var tilesCollectionTitle = "TileCollection-module--tilesCollectionTitle--3wnBV";